import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { api } from "@/lib/api";

export const EnquiriesTab = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/enquiries").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-tab-enquiries">
      <h2 className="mb-2 font-display text-2xl font-semibold text-ink">Booking enquiries</h2>
      <p className="mb-6 text-sm text-faint">Requests submitted through the website booking flow.</p>
      <div className="space-y-2">
        {items.map((e, i) => (
          <div key={e.id} data-testid={`admin-enquiry-${i}`} className="rounded-xl border border-ink/10 bg-white px-5 py-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="text-sm font-semibold text-ink">{e.name} · {e.phone}</p>
              <p className="text-xs text-faint">{dayjs(e.created_at).format("D MMM YYYY, h:mm A")}</p>
            </div>
            <p className="mt-1 text-xs text-plumsoft">
              {e.service} {e.date && `· ${e.date}`} {e.slot && `· ${e.slot} IST`}
            </p>
            {e.concern && <p className="mt-1 text-xs italic text-faint">“{e.concern}”</p>}
          </div>
        ))}
        {items.length === 0 && <p className="py-8 text-center text-sm text-faint">No enquiries yet.</p>}
      </div>
    </div>
  );
};
